(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("VueDemi"), require("FEGORender"), require("FEGOBridge"), require("FEGOWebapi"));
	else if(typeof define === 'function' && define.amd)
		define(["VueDemi", "FEGORender", "FEGOBridge", "FEGOWebapi"], factory);
	else if(typeof exports === 'object')
		exports["/fego/component/common-trade-idea-tab/render"] = factory(require("VueDemi"), require("FEGORender"), require("FEGOBridge"), require("FEGOWebapi"));
	else
		root["/fego/component/common-trade-idea-tab/render"] = factory(root["VueDemi"], root["FEGORender"], root["FEGOBridge"], root["FEGOWebapi"]);
})(self, (__WEBPACK_EXTERNAL_MODULE__9906__, __WEBPACK_EXTERNAL_MODULE__5322__, __WEBPACK_EXTERNAL_MODULE__7145__, __WEBPACK_EXTERNAL_MODULE__5113__) => {
return 